import * as React from 'react'

type Props = {
	delay?: number
	children: React.ReactNode
	fallback?: React.ReactNode
}

export default function DelayedMount({
	delay = 250,
	children,
	fallback = null,
}: Props) {
	const [isShowing, setShowing] = React.useState(false)

	React.useEffect(() => {
		const timeout = setTimeout(() => setShowing(true), delay)

		return () => {
			clearTimeout(timeout)
		}
	}, [delay])

	if (!isShowing) {
		return fallback
	}

	return children
}
